import cn from 'classnames';

import { FlyScrollShadowContainer } from '../../FlyScrollShadowContainer/FlyScrollShadowContainer';
import {
  TANSTACK_TABLE_SCROLL_FADE_GRADIENT_COLOR,
  TANSTACK_TABLE_SCROLL_FADE_GRADIENT_HEIGHT,
} from '../TanstackTable.types';

export type TanstackTableScrollViewportProps = {
  children: React.ReactNode;
  className?: string;
  gradientColor?: string;
  gradientHeight?: number;
  hideTop?: boolean;
  hideBottom?: boolean;
  contentClassName?: string;
  /** Optional external ref to the scroll container (e.g. for virtualizers). */
  scrollRef?: React.RefObject<HTMLDivElement | null>;
  onScroll?: React.UIEventHandler<HTMLDivElement>;
  scrollViewportTestId?: string;
};

/** Scroll container with top/bottom fade for TanstackTable `customRender` bodies. */
export function TanstackTableScrollViewport({
  children,
  className,
  gradientColor = TANSTACK_TABLE_SCROLL_FADE_GRADIENT_COLOR,
  gradientHeight = TANSTACK_TABLE_SCROLL_FADE_GRADIENT_HEIGHT,
  ...rest
}: TanstackTableScrollViewportProps) {
  return (
    <FlyScrollShadowContainer
      className={cn('min-h-0 w-full flex-1', className)}
      gradientColor={gradientColor}
      gradientHeight={gradientHeight}
      {...rest}
    >
      {children}
    </FlyScrollShadowContainer>
  );
}
